import React from "react";
import { ChartDataItem } from "../../types/dashboard";
import { useFormatAmount } from "../../../home/hooks/useFormatAmount";

interface DataSummaryProps {
  chartData: ChartDataItem[];
  businessType: string;
}

const DataSummary: React.FC<DataSummaryProps> = ({ chartData, businessType }) => {
  const formatAmount = useFormatAmount();

  const filteredChartData = businessType === "Restaurant" ? chartData.filter((item) => item.name !== "Outstanding") : chartData;

  const total = filteredChartData.reduce((sum, item) => sum + item.value, 0);
  const hasData = total > 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-2">
      {filteredChartData.map((entry, index) => {
        const percentage = hasData ? (entry.value / total) * 100 : 0;

        const displayValue = entry.name === "Orders" ? entry.value.toLocaleString() : formatAmount(entry.value);

        return (
          <div
            key={`detail-${index}`}
            className="group relative overflow-hidden rounded-xl bg-gradient-to-br from-white to-gray-50/80 border p-2 transition-all duration-200 border-gray-300/80 shadow-xs hover:shadow-sm"
          >
            <div className="absolute left-0 top-0 h-full w-1" style={{ backgroundColor: entry.color }} />

            <div className="relative z-10 pl-1.5">
              <div className="flex items-center justify-between mb-1">
                <div className="w-2.5 h-2.5 rounded-sm border border-white/50" style={{ backgroundColor: entry.color }} />

                <div
                  className="text-[10px] font-medium px-1 py-0.5 rounded-xl border backdrop-blur-sm"
                  style={{
                    backgroundColor: `${entry.color}15`,
                    color: entry.color,
                    borderColor: `${entry.color}25`,
                  }}
                >
                  {percentage.toFixed(0)}%
                </div>
              </div>

              <p className="text-base font-bold text-gray-900 mb-0">{displayValue}</p>

              <p className="text-[14px] font-medium text-gray-600 uppercase tracking-tight">{entry.name}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DataSummary;
